import React, { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { deleteNotificationFromListByUrl, setCollapsedNotificationsList } from '@fsd-entities/online-lessons';
import { useRole } from 'hooks';
import { useAppSelector } from 'store/store';

import { NotificationItem } from './NotificationItem';

import './OnlineLessonNotifications.style.scss';
export const OnlineLessonNotifications: React.FC = () => {
    const { meetingNotificationsList, collapsedNotificationsList } = useAppSelector((state) => state.onlineLessons);

    const dispatch = useDispatch();
    const { isTeacher, isStudent } = useRole();

    const hasOnlineLessons = !!meetingNotificationsList?.length;
    const showNotificationWindow = (isTeacher || isStudent) && hasOnlineLessons;

    const hasOverlay = useMemo(() => {
        const hasNotificationWithNoHideOption = meetingNotificationsList?.some(({ canHide }) => !canHide);
        const hasUncollapsedNotification = meetingNotificationsList?.some(
            ({ url }) => !collapsedNotificationsList.includes(url),
        );

        return hasNotificationWithNoHideOption || hasUncollapsedNotification;
    }, [collapsedNotificationsList, meetingNotificationsList]);

    const handleMeetingFinished = (url: string) => {
        dispatch(deleteNotificationFromListByUrl({ url }));
    };
    const handleCollapseNotification = (url: string) => {
        dispatch(setCollapsedNotificationsList([...collapsedNotificationsList, url]));
    };

    if (showNotificationWindow) {
        return (
            <div className={`online-lesson-notifications ${hasOverlay && 'with-overlay'}`}>
                <div className={'online-lesson-notifications__list'}>
                    {meetingNotificationsList?.map((meetingNotification) => {
                        const isNotificationItemCollapsed = collapsedNotificationsList.includes(
                            meetingNotification.url,
                        );
                        return (
                            <NotificationItem
                                key={meetingNotification.url}
                                isCollapsed={isNotificationItemCollapsed}
                                notification={meetingNotification}
                                handleCollapseNotification={handleCollapseNotification.bind(
                                    this,
                                    meetingNotification.url,
                                )}
                                handleMeetingFinished={handleMeetingFinished.bind(this, meetingNotification.url)}
                            />
                        );
                    })}
                </div>
            </div>
        );
    } else {
        return null;
    }
};
